import React from 'react';
import LocaleContext from 'constants/localization';

export default class FieldErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static contextType = LocaleContext;

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      const label = this.props.field ? this.props.field.label : '';
      return <label>{this.context.error.fieldCrash} {label}</label>;
      
    }
    return this.props.children; 
  }
}